import React from "react";
import { Button } from "components/generic/kit";
import { Input, Formik } from "components/generic/form/formik";
import { Title, Row, Label, ErrorBox } from "components/generic/form/service";
import { NarrowBody } from "components/generic/layout";
import { SignUpLayout } from "components/common/auth";

export default ({
  validationSchema,
  onSubmit,
  validate,
  insiderSignUpApi,
  errors
}) => (
  <SignUpLayout>
    <NarrowBody>
      <Formik
        initialValues={{
          first_name: "",
          last_name: "",
          email: "",
          password: "",
          password_confirmation: ""
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        errors={errors.field}
      >
        {props => (
          <div>
            <Title>Insider Sign Up</Title>
            {!!errors.nonField.length && <ErrorBox errors={errors.nonField} />}
            <form onSubmit={props.handleSubmit}>
              <Row>
                <Label title="First name">
                  <Input
                    name="first_name"
                    type="text"
                    placeholder="Enter your first name"
                  />
                </Label>
              </Row>
              <Row>
                <Label title="Last name">
                  <Input
                    name="last_name"
                    type="text"
                    placeholder="Enter your last name"
                  />
                </Label>
              </Row>
              <Row>
                <Label title="Email">
                  <Input
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                  />
                </Label>
              </Row>
              <Row>
                <Label title="Phone">
                  <Input.PhoneInput
                    name="phone"
                    type="text"
                    placeholder="Enter your phone number"
                  />
                </Label>
              </Row>
              <Row>
                <Label title="Password">
                  <Input
                    type="password"
                    name="password"
                    placeholder="Enter your password"
                  />
                </Label>
              </Row>
              <Row>
                <Label title="Password confirmation">
                  <Input
                    type="password"
                    name="password_confirmation"
                    placeholder="Enter password confirmation"
                  />
                </Label>
              </Row>

              <div className="mt3 flex items-center">
                <Button type="submit" disabled={insiderSignUpApi.isFetching}>
                  Sign Up
                </Button>
              </div>
            </form>
          </div>
        )}
      </Formik>
      <a href="https://www.thelobby.io" className="link dib mt2 brand">
        ← Back to the Homepage
      </a>
    </NarrowBody>
  </SignUpLayout>
);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/SignUp/View.js